import { createSlice } from "@reduxjs/toolkit";
import { boardViewForAllocation } from "./TransferOrderSliceV2";
import { sortAllView } from "../utils";

const paymentTermsDefaultColumns = [
  "NAME",
  "TERM TYPE",
  "DUE DAYS",
  "MONTH OFFSET",
  "DEFAULT",
  "DESCRIPTION",
  "ACTIVE",
  "CREATED BY",
];

const chartsAccountDefaultColumns = [
  "NAME",
  "CODE",
  "ACCOUNT TYPE",
  "CURRENCY",
  "ENABLE PAYMENTS TO ACCOUNT",
  "SHOW IN EXPENSE CLAIM",
  "DESCRIPTION",
  "CREATED BY",
];

/**
 * Default Journal Lines list columns (matches list API payload).
 *
 * @const
 * @type {!Array<string>}
 */
const journalLineDefaultColumns = [
  "ACCOUNT CODE",
  "ACCOUNT NAME",
  "AMOUNT",
  "CREATE DATE",
];

const initialState = {
  collabRoom: {},
  documents: [],
  members: [],
  roomData: [],
  chartsAccount: { count: 0, results: [] },
  chartsAccountParams: { limit: 10, offset: 0 },
  chartsAccountSelection: [],
  accountTypeSelection: [],

  chartsAccountLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: chartsAccountDefaultColumns,
      allViews: {
        "Default View": chartsAccountDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  paymentTerms: { count: 0, results: [] },
  paymentTermsParams: { limit: 10, offset: 0 },
  paymentTermSelection: [],
  paymentTermsLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: paymentTermsDefaultColumns,
      allViews: {
        "Default View": paymentTermsDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  journalLines: { count: 0, results: [] },
  journalLinesParams: { limit: 10, offset: 0 },
  journalLineLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: journalLineDefaultColumns,
      allViews: {
        "Default View": journalLineDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },

  oprAccountMaps: {},
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    getChartsAccount: (state, action) => {
      state.chartsAccount = action.payload;
    },
    getChartsAccountSelection: (state, action) => {
      state.chartsAccountSelection = action.payload;
    },
    setAccountTypeSelection: (state, action) => {
      state.accountTypeSelection = action.payload;
    },
    setChartsAccountLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.chartsAccountLayout = {
        ...state.chartsAccountLayout,
        listView: {
          ...state.chartsAccountLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.chartsAccountLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    setOperationalAccountMaps: (state, action) => {
      state.oprAccountMaps = action.payload;
    },

    updateChartsAccountParams: (state, action) => {
      state.chartsAccountParams = { ...state.chartsAccountParams, ...action.payload };
    },
    setPaymentTerms: (state, action) => {
      state.paymentTerms = action.payload;
    },
    setPaymentTermsSelection: (state, action) => {
      state.paymentTermSelection = action.payload;
    },
    setPaymentTermsLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.paymentTermsLayout = {
        ...state.paymentTermsLayout,
        listView: {
          ...state.paymentTermsLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.paymentTermsLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },

    updatePaymentTermsParams: (state, action) => {
      state.paymentTermsParams = { ...state.paymentTermsParams, ...action.payload };
    },
    setJournalLines: (state, action) => {
      state.journalLines = action.payload;
    },
    setJournalLineLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.journalLineLayout = {
        ...state.journalLineLayout,
        listView: {
          ...state.journalLineLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.journalLineLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    updateJournalLinesParams: (state, action) => {
      state.journalLinesParams = { ...state.journalLinesParams, ...action.payload };
    },
  },
});

export const {
  setAccountTypeSelection,
  getChartsAccount,
  getChartsAccountSelection,
  setChartsAccountLayoutAllViews,
  updateChartsAccountParams,
  setPaymentTerms,
  setPaymentTermsSelection,
  setPaymentTermsLayoutAllViews,
  updatePaymentTermsParams,
  setJournalLines,
  setJournalLineLayoutAllViews,
  updateJournalLinesParams,
  setOperationalAccountMaps,
} = accountSlice.actions;

export default accountSlice.reducer;
